import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import { configAPI } from '@/utils/api';

export default function ConfigCheck({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isConfigured, setIsConfigured] = useState(false);

  useEffect(() => {
    checkConfig();
  }, []);

  const checkConfig = async () => {
    // Don't check if already on setup page
    if (location.pathname === '/setup') {
      setIsChecking(false);
      return;
    }

    try {
      const response = await configAPI.isConfigured();
      const configured = response.data.is_configured;

      setIsConfigured(configured);

      if (!configured) {
        // Redirect to setup
        navigate('/setup', { replace: true });
      }
    } catch (error) {
      console.error('Failed to check configuration:', error);
      // On error, allow access (backend might not be ready yet)
      setIsConfigured(true);
    } finally {
      setIsChecking(false);
    }
  };

  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-muted-foreground">Checking configuration...</p>
        </div>
      </div>
    );
  }

  return children;
}
